import React from 'react';
import { makeStyles } from '@material-ui/core';

import HHLogoSmall from '../home/hh-logo-small.png';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 60,
  },
  path: {
    fill: '#7df3e1',
  },
});
const LogoFull = () => {
  const classes = useStyles();
  return <img alt="" className={classes.svg} src={HHLogoSmall} />;
};

export default LogoFull;
